import { Button } from "components/button";
import { Card } from "components/card";
import PageWrapper from "components/page-wrapper";
import { Link } from "react-router-dom";
import paths from "routes/paths";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import css from "./index.module.scss";

export const RequireTeamOwner = () => {
  const ownerEmail = useAppSelector(authNewSelectors.teamOwnerEmailGet);

  return (
    <PageWrapper centerVertically maxWidth={500} title="Add Credits">
      <Card className={css.card}>
        <h3 className={css.title}>
          Only the owner of the team can access this page.
        </h3>
        <p className={css.text}>
          Please contact or login as:
          <br />
          <strong>{ownerEmail}</strong>.
        </p>
        <Button as={Link} className={css.button} to={paths.searchSingle()}>
          Go back to search
        </Button>
      </Card>
    </PageWrapper>
  );
};
